function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import "./InstallImport.css";

var InstallImport = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InstallImport, _Component);

  function InstallImport() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = InstallImport.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        importAll = _this$props.importAll,
        isDefaultExport = _this$props.isDefaultExport,
        name = _this$props.name,
        packageName = _this$props.packageName;
    var compImport;

    if (importAll) {
      compImport = "* as " + name;
    } else {
      compImport = isDefaultExport ? name : "{" + name + "}";
    }

    return /*#__PURE__*/React.createElement("dl", {
      className: "Install__section"
    }, /*#__PURE__*/React.createElement("dt", {
      className: "InstallImport__dt"
    }, 'Installation'), /*#__PURE__*/React.createElement("dd", {
      className: "InstallImport__dd"
    }, /*#__PURE__*/React.createElement("code", {
      className: "code--standalone"
    }, "npm install --save " + packageName)), /*#__PURE__*/React.createElement("dt", {
      className: "InstallImport__dt"
    }, 'Importing'), /*#__PURE__*/React.createElement("dd", {
      className: "InstallImport__dd"
    }, /*#__PURE__*/React.createElement("code", {
      className: "code--standalone"
    }, "import " + compImport + " from '" + packageName + "';")));
  };

  return InstallImport;
}(Component);

InstallImport.propTypes = {
  importAll: PropTypes.bool,
  isDefaultExport: PropTypes.bool,
  name: PropTypes.string.isRequired,
  packageName: PropTypes.string.isRequired
};
InstallImport.defaultProps = {
  importAll: false,
  isDefaultExport: false
};
export default InstallImport;
//# sourceMappingURL=InstallImport.js.map